import { z } from "zod";
import { getIdSchema, ID, makeIdGenerator } from "../utils";

export const deviceSubmissionIdPrefix = "dsm_";
export type DeviceSubmissionId = ID<typeof deviceSubmissionIdPrefix>;
export const generateDeviceSubmissionId = makeIdGenerator(
  deviceSubmissionIdPrefix,
);
export const deviceSubmissionIdSchema = getIdSchema(
  deviceSubmissionIdPrefix,
  "DeviceSubmissionId",
);

export const deviceSubmissionSchema = z.object({
  id: deviceSubmissionIdSchema,
  time: z.coerce.date(),
  // The raw device-supplied identifier (hardware id or prefixed id). Stored
  // verbatim for debugging — not a strict FK to Device.
  deviceId: z.string().nullable(),
  body: z.instanceof(Uint8Array),
  error: z.string().nullable(),
  responseCode: z.number(),
  responseCodeForced: z.boolean(),
  responseBody: z.instanceof(Uint8Array),
});

export type DeviceSubmission = z.infer<typeof deviceSubmissionSchema>;
